import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LineChart } from 'lucide-react';
import { useAuth } from '../../features/auth/AuthContext';
import { AdRenderer } from '../../components/ads/AdRenderer';
import { PublicFooter } from '../../components/common/PublicFooter';

export function PublicLayout({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const goDashboard = () => {
    if (!user) return navigate('/');
    navigate(user.roles.includes('admin') ? '/admin/dashboard' : '/member/dashboard');
  };

  return (
    <div className="min-h-screen bg-[#050914] text-white selection:bg-cyan-400/30">
      <AdRenderer />
      <header className="h-20 sticky top-0 z-30 bg-[#050914]/85 backdrop-blur-md border-b border-white/10 flex items-center justify-between px-4 sm:px-10">
        <Link to="/courses" className="flex items-center gap-3 min-w-0" data-testid="public-brand">
          <div className="w-9 h-9 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.25)] shrink-0">
            <LineChart className="w-5 h-5 text-cyan-400" strokeWidth={1.5} />
          </div>
          <div className="leading-tight min-w-0">
            <p className="text-white font-medium tracking-tight truncate">Cuantrader</p>
            <p className="text-[10px] uppercase tracking-[0.25em] text-cyan-400/80">Community</p>
          </div>
        </Link>
        <nav className="flex items-center gap-1.5 sm:gap-3 shrink-0">
          <Link to="/courses" className="text-white/70 hover:text-cyan-400 px-3 sm:px-4 py-2 rounded-lg transition-colors text-sm">
            Courses
          </Link>
          {user ? (
            <button
              onClick={goDashboard}
              data-testid="public-dashboard-button"
              className="bg-cyan-400 text-[#050914] font-medium px-4 sm:px-5 py-2 rounded-lg transition-colors hover:bg-cyan-300 text-sm whitespace-nowrap"
            >
              Dashboard
            </button>
          ) : (
            <Link
              to="/"
              data-testid="public-login-button"
              className="bg-cyan-400 text-[#050914] font-medium px-4 sm:px-5 py-2 rounded-lg transition-colors hover:bg-cyan-300 text-sm whitespace-nowrap"
            >
              Masuk / Login
            </Link>
          )}
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-10 py-10 animate-in fade-in slide-in-from-bottom-4 duration-500">
        {children}
      </main>
      <PublicFooter />
    </div>
  );
}
